// Generated by CoffeeScript 1.12.7
angular.module(__filename, [require('angular-klaxon').name]).run([
  '$window', '$rootScope', 'KlaxonAlert', function($window, $rootScope, KlaxonAlert) {
    var alert;
    alert = new KlaxonAlert("You appear to be offline.", {
      type: 'danger',
      closable: false,
      priority: 99999
    });
    $window.addEventListener('offline', function() {
      return $rootScope.$apply(function() {
        return alert.add();
      });
    });
    $window.addEventListener('online', function() {
      return $rootScope.$apply(function() {
        return alert.close();
      });
    });
    if (navigator.onLine === false) {
      return alert.add();
    }
  }
]);

module.exports = __filename;
